module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/footer/logo_ft-5d17b952c1219c4c096978f71c66fbd4.png";